import type { TierCardDesign, CardLayout } from "../../api/rewardsAdminHooks";

export const LAYOUT_OPTIONS: { value: CardLayout; label: string; desc: string }[] = [
  { value: "classic", label: "Classic", desc: "หัวบน ชื่อเทียร์ล่าง" },
  { value: "centered", label: "Centered", desc: "ทุกอย่างอยู่กลาง" },
  { value: "minimal", label: "Minimal", desc: "ชื่อเทียร์มุมขวาล่าง" },
  { value: "badge", label: "Badge", desc: "โลโก้กลางบน ชื่อล่าง" },
  { value: "split", label: "Split", desc: "ซ้ายข้อความ ขวาโลโก้" },
  { value: "bar", label: "Bar", desc: "แถบฝ้าล่าง" },
];

export const PRESET_CARDS: { label: string; design: Partial<TierCardDesign> }[] = [
  { label: "Slate", design: { bg_type: "gradient", bg_color: "#334155", bg_color_end: "#0f172a", bg_angle: 135, text_color: "#ffffff" } },
  { label: "Ocean", design: { bg_type: "gradient", bg_color: "#0ea5e9", bg_color_end: "#1e40af", bg_angle: 135, text_color: "#ffffff" } },
  { label: "Rose Gold", design: { bg_type: "gradient", bg_color: "#f43f5e", bg_color_end: "#be185d", bg_angle: 135, text_color: "#ffffff" } },
  { label: "Emerald", design: { bg_type: "gradient", bg_color: "#10b981", bg_color_end: "#065f46", bg_angle: 135, text_color: "#ffffff" } },
  { label: "Gold", design: { bg_type: "gradient", bg_color: "#f59e0b", bg_color_end: "#92400e", bg_angle: 135, text_color: "#ffffff" } },
  { label: "Midnight", design: { bg_type: "solid", bg_color: "#020617", text_color: "#e2e8f0" } },
  { label: "Snow", design: { bg_type: "solid", bg_color: "#ffffff", text_color: "#1e293b" } },
  { label: "Purple", design: { bg_type: "gradient", bg_color: "#8b5cf6", bg_color_end: "#4c1d95", bg_angle: 135, text_color: "#ffffff" } },
];

export const PATTERNS = [
  { value: null as string | null, label: "ไม่มี" },
  { value: "dots", label: "จุด" },
  { value: "lines", label: "เส้น" },
  { value: "grid", label: "ตาราง" },
  { value: "diagonal", label: "ทแยง" },
];

export const DEFAULT_DESIGN: TierCardDesign = {
  bg_type: "solid",
  bg_color: "#1e293b",
  bg_color_end: "#0f172a",
  bg_angle: 135,
  text_color: "#ffffff",
  pattern: null,
  pattern_opacity: 15,
  layout: "classic",
  logo_mode: "none",
  logo_image: null,
  logo_text: null,
  label_text: null,
  subtitle_text: null,
};

export function buildCardBackground(d: Pick<TierCardDesign, "bg_type" | "bg_color" | "bg_color_end" | "bg_angle">): React.CSSProperties {
  if (d.bg_type === "gradient" && d.bg_color_end) {
    return { background: `linear-gradient(${d.bg_angle ?? 135}deg, ${d.bg_color}, ${d.bg_color_end})` };
  }
  return { backgroundColor: d.bg_color };
}

export function buildPatternOverlay(d: Pick<TierCardDesign, "text_color" | "pattern">): string | null {
  const c = d.text_color || "#ffffff";
  switch (d.pattern) {
    case "dots":
      return `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><circle cx='12' cy='12' r='1.5' fill='${c}'/></svg>`;
    case "lines":
      return `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><line x1='0' y1='12' x2='24' y2='12' stroke='${c}' stroke-width='0.5'/></svg>`;
    case "grid":
      return `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><line x1='0' y1='12' x2='24' y2='12' stroke='${c}' stroke-width='0.3'/><line x1='12' y1='0' x2='12' y2='24' stroke='${c}' stroke-width='0.3'/></svg>`;
    case "diagonal":
      return `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><line x1='0' y1='0' x2='24' y2='24' stroke='${c}' stroke-width='0.5'/></svg>`;
    default:
      return null;
  }
}
